<template>
  <div>
    <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">

      <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
        <label v-if="canEdit" class="a-form-label" for="name">
          {{ $t('label-gathering-name') }}<required-form-field />
          <span class="m-form-group__note m-form-group__note--small">{{ $t('detail-label-gathering-name') }}</span>
        </label>
      </div>
    
      <div class="h-grid__col h-grid__col-12">
        <div class="m-form-highlight m-form-highlight--primary-color h-remove-child-margin">
          <span class="m-form-highlight__detail m-form-highlight__detail--light">{{ $t('label-edit-gathering-name-prefix').toUpperCase() }}</span>
          <div v-if="canEdit" class="m-form-highlight__cell">
            <div class="m-form-group">
              <span class="m-form-group m-form-group--inline">
                <input 
                  class="a-form-control a-form-control--huge a-form-control--dark-mode" 
                  v-model.trim="name" :placeholder="$t('label-edit-gathering-name-placeholder')" 
                  autocomplete="create-gathering gathering-name" 
                />
              </span>
              <span v-if="showError">
                <span class="m-form-group__error">{{ $t('error-field-required') }}</span>
              </span>
            </div>
          </div>
          <div v-else class="m-form-highlight__title m-form-highlight__title-light">
            <span class="a-title-huge a-title-huge--800 a-title-huge--white">{{ name }}</span>
          </div>
          <span class="m-form-highlight__detail m-form-highlight__detail--light">{{ $t('label-edit-gathering-name-suffix').toUpperCase() }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    },
    showError: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    name: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
